import React from 'react';
import appconfig from '@/utils/appConfig';
import clsx from 'clsx';

interface FormRowBaseProps {
    label: string;
    /** * React.ReactNode allows anything that can be rendered:
     * jsx, strings, numbers, fragments, etc.
     */
    content: React.ReactNode;
    className?: string;
    required?: boolean;
}

export const NonFormRow = ({
    label,
    content,
    className,
    required,
}: FormRowBaseProps) => {
    const nonFormRowStyle = `flex mb-2 border-2 ${appconfig.colors.primaryBorder} flex-wrap sm:flex-nowrap`;
    const nonFormLabelStyle = `w-full sm:w-80 flex p-2 text-md items-center ${appconfig.colors.primaryBg} ${required ? 'required' : ''}`;
    const nonFormCalcStyle =
        'w-full flex flex-grow justify-start items-center p-2';

    return (
        <div className={`${nonFormRowStyle} ${className ? className : ''}`}>
            <div className={nonFormLabelStyle}>{label}</div>
            <div className={nonFormCalcStyle}>{content}</div>
        </div>
    );
};

export const FormRow = ({
    label,
    content,
    className,
    required = true,
}: FormRowBaseProps) => {
    const formRowStyle = clsx(
        `flex mb-2 border-2 ${appconfig.colors.primaryBorder} flex-wrap sm:flex-nowrap`
    );
    const formLabelStyle = clsx(
        `w-full sm:w-80 flex p-2 text-md items-center ${appconfig.colors.primaryBg}`,
        required ? 'required' : ''
    );
    const formCalcStyle = 'w-full flex flex-grow justify-start items-center';

    return (
        <div className={`${formRowStyle} ${className ? className : ''}`}>
            <div className={formLabelStyle}>{label}</div>
            <div className={formCalcStyle}>{content}</div>
        </div>
    );
};
